export const INVITATION_NOT_ACCEPTED = 0;
export const INVITATION_ACCEPTED = 1;
export const INVITATION_CANCELLED = 2;
export const INVITATION_DECLINED = 3;

export const LOGIN_PASSWORD_RESET_REQUEST_SENT = 28;
export const LOGIN_PASSWORD_RESET_SUCCESSFUL = 29;
export const LOGIN_PASSWORD_REQUEST_EXPIRED = 30;
export const LOGIN_LOGIN_TO_CONFIRM_EMAIL = 32;

export const ACCESS_LEVEL_REPORT = 10;
export const ACCESS_LEVEL_LIMITED = 20;
export const ACCESS_LEVEL_STANDARD = 30;
export const ACCESS_LEVEL_FULL = 40;
export const ACCESS_LEVEL_OWNER = 1010;

/**
 * Local Storage Constants
 */
export const LOCAL_AUTH_TOKEN = 'auth_token';
export const LOCAL_AUTH_TOKEN_EXPIRY = 'auth_token_expiry_time';

/**
 * Auth Type Constants (Bitwise)
 */
export const AUTH_OATH       = 0x01;
export const AUTH_SMS        = 0x02;
export const AUTH_SMS_BACKUP = 0x04; // Reserved but not used
export const AUTH_BACKUP     = 0x08;
export const AUTH_RECOVERY   = 0x10; // Always available, but never set
export const AUTH_EMAIL      = 0x20;

// Don't need to be signed in for these pages
export const ANON_PAGES = [ '/confirm', '/forgot', '/reset' ];

// Don't need to show the header for these pages
export const PRINT_ONLY_PAGES = [ '/backup_codes' ];

export const SSO_MFA_PAGES = [ '/security', '/backup_codes' ];

export const SSO_PASSWORD_PAGES = [ '/password' ];

export const LOCALES = {
    'en-au': 'English (Australian)',
    'en-us': 'English (US)',
    'es-mx': 'Español mexicana'
};